import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Footer } from './footer'
import { MatterportIframe } from './iframe'
import { Select } from './select'
import models from '../models.json'
import './app.sass';

const SDKContext = React.createContext<any>(null)

export function App() {
  const ref = useRef((s: any) => setSDK(s))
  const [model, setModel] = useState<string>(process.env.REACT_APP_MATTERPORT_MODEL_ID!)
  const [sdk, setSDK] = useState<any>(null)

  useEffect(() => {
    if (models && models.length > 0) {
      setModel((models as Array<any>)[0].id)
    }
  }, [])

  const onSelect = useCallback((value: string | null): void => {
    if (value != null) {
      setModel(value)
    }
  }, [])

  return (
    <SDKContext.Provider value={sdk}>
      {(models && models.length && <Select list={models} onChange={onSelect} />) || null}
      <MatterportIframe setSDK={ref.current} model={model} />
      <Footer />
    </SDKContext.Provider>
  )
}